export default function OneCardRules({ show, onClose }) {
    if (!show) return null;

    return (
        <>
            <style>
                {`
                    h1{
                        font-size: 40px;
                        font-weight: 800;
                    }
                    h3 {
                        font-size: 28px;
                    }
                    p{
                        font-size: 15px;
                        font-weight: 500;
                    }    
                    .modal-header {
                        background-color: #fff;
                        color: #000;
                        padding: 1rem;
                        display: flex;
                        align-items: center;
                        max-width: 100% !important;
                        width: 100%
                    }
                    .modal-content {
                        max-width: 800px;
                        max-height: 100vh;
                        margin-top: 25px;
                        background-color: #fff;
                        color: #000;
                        border-radius: 8px;
                        margin-left: auto; 
                        margin-right: auto; 
                        width: 100% !important;
 
                    }
                    .imgt20 {
                        max-width: 100%;  
                        height: auto;     
                        display: block;
                    }
                    .modal-overlay {
                        position: fixed; 
                        top: 0;
                        left: 0;
                        width: 100vw;
                        height: 100vh;
                        background: rgba(0, 0, 0, 0.5);
                        display: flex;
                        justify-content: center;
                        align-items: flex-start;
                        z-index: 9999;
                        overflow-y: auto;
                        }
                `}
            </style>
            {show && (
                <div className="modal-overlay">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="exampleModalLabel">Market Rules</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close" onClick={onClose}>
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <div id="market-rules-text" class="modal-body">
                            <div>
                                <div>
                                    <center>
                                        <h1><b>One Card 20 20</b></h1>
                                        <h2>Rules and Regulations</h2>
                                        <hr></hr>
                                        <div>
                                            <h3><b>GAME OBJECTIVES</b></h3>
                                            <p class="pt20">The objective of the game is to guess whether the player or dealer will draw a card of the higher value and will therefore win.</p>
                                        </div>

                                        <div>
                                            <h3><b>GAME RULES</b></h3>
                                            <p class="pt20"><b> 1 CARD 20-20 is a very easy and fast paced game.</b></p>
                                            <p class="pt20"><b>This game is played with 8 decks of regular 52 cards between the player and dealer.</b></p>
                                            <p class="pt20"><b>Both, the player and dealer will be dealt one card each.</b></p>
                                            <p class="pt20">The objective of the game is to guess whether the player or dealer will draw a card of the higher value and will therefore win.</p>
                                            <p class="pt20">You can place your bets on the player as well as dealer.</p>

                                            <p class="pt20"><b>Ranking of cards: from lowest to highest</b></p>
                                            <p class="pt20"><b>2 , 3 , 4 , 5 , 6 , 7 , 8 , 9 , 10 , J , Q , K , A :</b>If the player and dealer both have the same hands with the same ranking cards but of different suits then the winner will be decided according to the order of the suits</p>
                                            <p class="pt20">
                                                <b>Order of suits: </b>from highest to lowest
                                            </p>
                                            <p class="pt20">
                                                Spades , Hearts , Clubs , Diamonds =&gt; eg Clubs ACE Diamonds ACE =&gt; Here ACE of Clubs wins.
                                            </p>
                                            <p class="pt20">If both,the player and dealer hands have the same ranking cards which are of the same suit, then it will be a TIE.</p>
                                            <p class="pt20">eg Spades ACE Spades ACE</p>
                                            <p class="pt20">In case of a TIE ,bets placed on both the player and dealer will lose the bet amount.</p>
                                        </div>
                                        <h3><b>Side Bets</b></h3>
                                        <p class="pt20"><b>Pair :</b>Here you can bet that both, the player and dealer will have the same ranking cards irrespective of suits</p>
                                        <p class="pt20"><b>Tie :</b>Here you can bet that the game will be a Tie.</p>
                                        <p class="pt20">
                                            <b>Note :</b>:
                                            In case of a Tie between the player and dealer, bets placed on Side bets will be considered valid.
                                        </p>

                                    </center>
                                </div>
                            </div>

                        </div>
                    </div>


                </div>
            )}
        </>
    );
}